import { MARQUEE_ITEMS } from "@/data/content";

const Row = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {MARQUEE_ITEMS.map((item) => (
      <span key={`${item}-${ariaHidden}`} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-lg italic text-cream/90 sm:text-xl">
          {item}
        </span>
        <span className="text-gold" aria-hidden="true">
          ✦
        </span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-label="What companionship with Adeya feels like"
    className="overflow-hidden border-y border-navy/20 bg-navy py-5"
  >
    <div className="flex w-max animate-marquee motion-reduce:animate-none">
      <Row />
      <Row ariaHidden />
    </div>
  </section>
);
